import React from 'react';
import { NavDropDownButton } from '@trussworks/react-uswds';

export function USWDSNavDropDownButton(props) {
  return <NavDropDownButton {...props} />;
}
